import { useGetSubstitutionChangesHistoryQuery } from 'app/services/edpApiV1/substitutions/substitution';
import { convertDate } from 'shared/helpers/date';
import { EmployeesUi } from 'entities/employees';
import style from './index.module.scss';

interface IProps {
  substitutionId: string;
}
export const ChangesHistory: React.FC<IProps> = ({ substitutionId }) => {
  const { data } = useGetSubstitutionChangesHistoryQuery(substitutionId);

  return data && data?.data.length !== 0 ? (
    <div className={style.wrap}>
      <h4>История замещений:</h4>
      <div className={style.changesHistory}>
        {data?.data.map(item => (
          <div key={item.id} className={style.changesHistoryItem}>
            {item.isAuto ? (
              <span>Завершено автоматически</span>
            ) : (
              <EmployeesUi.SummaryInfo user={item.creator} showPersonnelNumber={false} initials={true} />
            )}
            <div className={style.period}>
              {convertDate(item.validFrom)} - {convertDate(item.validTo)}
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};
